<template>
  <div
    v-if="!responded && !hiddenRoutes.includes($route.name)"
    class="consent-banner"
    :style="{ borderColor: providerColor, '--provider-color': providerColor }"
  >
    <VpIcon
      icon="exclamation-circle"
      id="consent-banner__icon__attention"
      class="consent-banner__icon"
      :style="{
        color: providerColor,
        fontSize: '16px',
        minWidth: '16px',
        minHeight: '16px',
      }"
    />
    <div class="consent-banner__text">
      <p class="consent-banner__header">{{ $t('gaConsentPrivacyHeader') }}</p>
      <p class="consent-banner__body" v-html="gaConsentBannerText" />
    </div>
    <div class="consent-banner__actions">
      <vp-button
        id="consent-banner__accept"
        :styles="buttonStyles"
        @click="handleAccept"
      >
        {{ $t('gaConsentAccept') }}
      </vp-button>
      <vp-button
        id="consent-banner__decline"
        class="no-fill"
        :styles="buttonStyles"
        @click="handleDecline"
      >
        {{ $t('gaConsentDecline') }}
      </vp-button>
    </div>
  </div>
</template>

<script>
import { initializeAnalytics } from '../main';

export default {
  name: 'consent-banner',
  props: {
    customerConfig: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      responded: false,
      consented: false,
      hiddenRoutes: ['success', 'newDeviceSuccess', 'error'],
    };
  },
  created() {
    const cached = window.sessionStorage.getItem('gaConsent');
    this.responded = cached !== null;
    this.consented = cached === 'accept';
  },
  mounted() {
    // if policy was accepted earlier this session tracking can begin
    if (this.consented) {
      initializeAnalytics();
      window.analyticsInitialized = true;
    }
  },
  computed: {
    gaConsentBannerText() {
      return this.$t('gaConsentBannerText');
    },
    providerColor() {
      return this.customerConfig.color || '#016699';
    },
    buttonStyles() {
      return {
        backgroundColor: this.providerColor,
        border: `${this.providerColor} solid 2px`,
        hoverBorder: `${this.providerColor} solid 2px`,
      };
    },
  },
  methods: {
    handleAccept() {
      this.responded = true;
      initializeAnalytics();
      window.analyticsInitialized = true;
      this.storeResponse('accept');
    },
    handleDecline() {
      this.responded = true;
      this.storeResponse('decline');
    },
    storeResponse(response) {
      window.sessionStorage.setItem('gaConsent', response);
    },
  },
};
</script>

<style lang="scss">
.consent-banner {
  margin: 16px 30px;
  padding-left: 15px;
  padding-right: 15px;
  max-width: 100%;

  @media (min-width: 576px) {
    max-width: 480px;
    margin: 16px auto;
  }
  @media (min-width: 768px) {
    max-width: 660px;
    margin: 16px auto;
  }
  @media (min-width: 992px) {
    max-width: 590px;
  }
  @media (min-width: 1200px) {
    max-width: 710px;
  }

  display: flex;
  align-items: flex-end;
  gap: 16px;
  background: #fff;
  border: 1px solid;
  border-radius: 8px;
  padding-top: 12px;
  padding-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  flex-wrap: wrap;

  &__icon {
    align-self: center;
    margin-top: 2px;
  }

  &__text {
    color: #1B3664;
    flex: 1 1 0%;
  }

  &__header {
    font-size: 12px;
    font-weight: 700;
    margin-bottom: 0;
  }

  &__body {
    font-size: 12px;
    margin-bottom: 0;

    a {
      text-decoration: underline;
    }
  }

  &__actions {
    display: flex;
    align-self: center;
    gap: 8px;

    #consent-banner__accept, #consent-banner__decline {
      min-width: 108px;

      @media (min-width: 576px) {
        padding: 2px 8px;
      }

      &:focus {
        outline: none;
      }

      &:focus-visible {
        outline: #7eb0ca solid 3px;
      }
    }

    #consent-banner__decline {
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: var(--provider-color);
        opacity: 0;
        transition: opacity 0.5s ease;
      }

      &:hover::before {
        opacity: 0.15;
      }
    }

    @media (max-width: 767px) {
      flex-basis: 100%;

      #consent-banner__accept, #consent-banner__decline {
        flex: 1 1 auto;
      }
    }
  }
}
</style>
